import { Controller } from "@hotwired/stimulus"

// Wrapper controller that automatically triggers confetti on connect
// Uses a hidden button approach as suggested in the stimulus-confetti GitHub issues
export default class extends Controller {
  static targets = ["trigger"]

  connect() {
    // Wait a small delay to ensure the confetti controller is connected
    setTimeout(() => {
      if (this.hasTriggerTarget) {
        // Create a synthetic click event at the center of the image
        // This provides a real click event with clientX and clientY at the center
        const rect = this.element.getBoundingClientRect()
        const centerX = rect.left + rect.width / 2
        const centerY = rect.top + rect.height / 2
        
        const clickEvent = new MouseEvent('click', {
          view: window,
          bubbles: true,
          cancelable: true,
          clientX: centerX,
          clientY: centerY
        })
        
        // Dispatch the event on the trigger button
        this.triggerTarget.dispatchEvent(clickEvent)
      }
    }, 100)
  }

}

